  <template>
    <div>
      <!-- Header -->
      <div class="header py-5 py-lg-7 pt-lg-7">
        <div v-if="false" class="separator separator-bottom separator-skew zindex-100">
          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </div>

      <!-- Page content -->
      <b-container class="mt--8 pb-0">
        <b-row class="justify-content-center pt-5">
          <b-col lg="5" md="7">
            <b-card no-body class="bg-light">
              <b-card-body class="" style="padding-left: 40px; padding-right: 40px;">
                <span class="w-100 d-block text-center">
                  <img src="img/janoo-logo-v2-high-color.png" style="max-width: 280px; height: auto;" class="pt-4 pb-3 justify-content-center align-items-center display-flex" />
                </span>

                <div v-if="true" style="color: #3E3E3E;" class="mb-1 pt-3">
                  <h3 class="pb-2">{{ loginFormTitle }}</h3>
                  <small style="font-weight: 600; color: gray;">Usuário ou e-mail</small>
                </div>

                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                  <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                    <base-input v-model="form.username" @keyup="usernameOnChange" id="input-login" alternative class="mb-3" name="Usuário" :rules="{ required: true }"
                      prepend-icon="no no-mail" placeholder="Nome do usuário ou e-mail">
                    </base-input>

                    <small style="font-weight: 600; color: gray;">Senha</small>

                    <base-input v-model="form.password" id="input-senha" alternative class="mb-0" name="Digite sua senha"
                      :rules="{ required: true, min: 1 }" prepend-icon="no no-lock" type="password" placeholder="Senha">
                    </base-input>

                    <div class="invalid-feedback mt-3 mb-0" style="display: block;font-size: large;line-height: 2;">
                      {{`&nbsp;${errorText}` }}
                    </div>

                    <b-form-checkbox v-if="false" v-model="form.rememberMe">Lembre-me</b-form-checkbox>

                    <div class="text-center pt-0">
                      <base-button type="primary" native-type="submit" id="loginButton" :disabled="disableLoginButton" class="my-1 mb-3 btn-block">
                        {{ loginButtonText }}
                        <!--  @click="validateLogin" -->
                      </base-button>
                    </div>

                    <b-row>
                      <div class="text-gray text-center w-100 pb-5">
                        <a href="/forgot-password" class="pr-4 text-gray" style="font-size: 14px; text-decoration-line: underline;">Recuperar Senha</a>
                        <a href="/register" class="text-gray" style="font-size: 14px; text-decoration-line: underline;">Criar nova conta</a>
                      </div>
                    </b-row>

                      <small v-show="form.pid">
                        <div class="text-right mt-4">
                          não é cadastrado?
                          <router-link :to="{ path: '/register' + (form.pid != undefined ? '?pid=' + form.pid : '') }">
                            criar conta
                          </router-link>
                        </div>
                      </small>
                  </b-form>
                </validation-observer>
              </b-card-body>
            </b-card>

            <b-row class="  ">
              <b-col v-if="false" cols="6">
                <router-link to="/forgot-password" class="text-light"><small>Esqueceu sua senha?</small></router-link>
              </b-col>

              <b-col v-if="false" cols="6" class="text-right">
                <router-link to="/register" class="text-light"><small>Criar uma conta</small></router-link>
              </b-col>
            </b-row>

          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>

<script>
import { mapActions, mapGetters } from "vuex"
import { startReleaseWatch } from "@/services/releaseCheck"

export default {
  name: "UserLogin",

  data() {
    return {
      bcVersion: process.env.VUE_APP_VERSION,
      form: { email: "", username: "", password: "", rememberMe: false },
      showAlert: false,
      loginFormTitle: 'Bem vindo ao seu dashboard',
      loginButtonText: "Entrar",
      errorText: "",
      disableLoginButton: false,
      place_public_data: {},
    };
  },

  watch: {
    form(newValue, oldValue){
      this.disableLoginButton = false

      if (!newValue.username) {
        document.querySelector('input#input-login').focus()
        setTimeout(() => { document.querySelector('input#input-login').blur() }, 50)
      }
      else if (!newValue.password) {
        document.querySelector('input#input-senha').focus()
        setTimeout(() => { document.querySelector('input#input-senha').blur() }, 50)
      }
      // else {
      //   this.loginButtonText = "Aguarde..."
      //   this.disableLoginButton = true
      // }
    },

  },

  computed: {
    ...mapGetters('auth', {
      user: 'user'
    }),
  },

  methods: {
    ...mapActions('auth', [
      'loginRequest',
      'logoutRequest',
    ]),

    ...mapActions('report', [
      'reportStoreCommit',
    ]),

    ...mapActions('product', [
      'resetChartsCache',
    ]),

    usernameOnChange() { this.form.username = this.form.username.toLowerCase().replace(/\s/g, '') },

    receiveMessageIframe(event) {
      if (event.origin.endsWith("bocapio.com.br") || event.origin.endsWith("janoo.com.br") || event.origin.endsWith("bocapio.com")) {
        try {
          this.showAlert = false
          const data = JSON.parse(event.data)
          if (data.status === "error" || data.status === "warning") {
            // if (process.env.NODE_ENV != "production") {
            // }
            this.loginButtonText = "Entrar"
            this.errorText = data.flash.message
            this.disableLoginButton = false
            this.showAlert = true
            this.logout()
          }
        } catch (error) { }
      }
    },

    async logout() {
      await this.resetChartsCache()
      this.logoutRequest().then(() => {
        localStorage.removeItem('vuex')
        this.$route.name !== "userLogin" ? this.$router.push("/login?loginmode=auto") : ""
      });
    },

    //used by cake_login_logout.js
    enableLoginButton() { this.disableLoginButton = false },

    facebookLogin() {
      window.FB.login(response => {
        if (process.env.NODE_ENV != "production") {
        }
      }, this.params);
    },

    async onSubmit() {
      // this will be called only after form is valid.
      // You can do api call here to login
      this.disableLoginButton = true
      this.showAlert = false;
      const { username, password } = this.form
      let homepage = ""

      await this.loginRequest({ username, password })
        .then(rsp => {
          document.body.classList.remove('bg-dark')
        })
        .catch(e => {
          if (process.env.NODE_ENV != "production") {
          }
          this.errorText = e.message
          this.loginButtonText = "Entrar"
          this.showAlert = true
          this.disableLoginButton = false
          return
        })

      try {
        homepage = JSON.parse(this.user.params).User.indexpage
        if (window.parent == window) {
          homepage = homepage.replace('layout@janoo', '')
        }
      } catch (error) { }

      let resolved = this.$router.resolve(homepage)
      this.showAlert = false

      if (null != window.opener) {  //is popup?
        // if (window.opener) {
        //   window.opener.postMessage(JSON.stringify({ 'status': 'popuped', 'cakeuserdata': JSON.parse(this.user.params).User }), '*')
        // }
      }
      else {
        if (resolved.route.name != '404' && resolved.route.name != 'userLogin') {
          //   let resolvedRoute = decodeURIComponent(resolved.href).replace(/@/g, '=')
          //   const navigationResult = await this.$router.push(resolvedRoute)
          // } else {
          this.$router.push("/loading").catch((e) => e);
        }
        else {
          this.$router.push("/dashboard/index")
        }
      }
    },

  },

  async created() {
    await this.resetChartsCache()

    startReleaseWatch()
    console.log('sistema.janoo.com.br® version: ', this.bcVersion)

    if (window.location.href.indexOf('janoo.com.br') > 0 || this.$route.query.hosted == 'janoo') {
      this.bcClasses += 'janoo_hosteded '
    }

    document.body.classList.add('bg-dark')
    this.form.pid = (new URLSearchParams(window.location.search.slice(1))).get('pid')

    this.$parent.$parent.$on('place_public_data_loaded', () => { this.place_public_data = this.$parent.$parent.place_public_data })
  },

  async mounted() {
    if (JSON.parse(localStorage.getItem('vuex')) && JSON.parse(localStorage.getItem('vuex')).product.pois.length) {
      localStorage.removeItem('vuex')
    }

    if (process.env.NODE_ENV !== 'production' || this.$route.query.debug == 'true') {
      window.jdebug = this
    }

    //used by cake_login_logout.js
    window.enableLogin = this.enableLoginButton()

    // let cakeLoginScript = document.createElement("script")
    // cakeLoginScript.setAttribute("src", process.env.VUE_APP_CAKE_LOGIN_LOGOUT + '?uts=' + (new Date()).getTime())
    // document.head.appendChild(cakeLoginScript)
    // window.addEventListener("message", this.receiveMessageIframe, false)
    // document.querySelector('input#input-login').focus()
    // document.querySelector('input#input-login').focus()
  },

}
</script>

<style lang="css">
#input-senha .invalid-feedback,
#input-login .invalid-feedback {
  position: absolute;
  text-align: right;
  float: right;
  right: 0px;
  padding-right: 3rem !important;
}
</style>
